<script>
import './style.scss';
import template from './template.html';
import axios from 'axios';
import {CommentIcon, ExclamationThickIcon, FlagIcon, PencilIcon, PlusCircleIcon, TrashCanIcon} from '../icons.js';
import Switches from 'vue-switches';
import {debounce, isArray, maxBy, values, sortBy, orderBy} from 'lodash';
import moment from 'moment';
import Comment from './Comment.vue';

const DATE_FORMAT = 'YYYY-MM-DD';

export default {

    props: {
        orderId: {
            default: '',
            type: [String, Number]
        },

        lockOrder: {
            default: false,
            type: Boolean
        }
    },

    watch: {

        /**
         * Watch editor and cache changes
         *
         * @param {String} newValue
         * @return void
         */
        'editor': function (newValue) {
            this.cacheComment(newValue, this.orderId);
        },
    },

    created() {

        //get the cached edtior state
        this.getCommentCache().then(result => {
            if (result && result.body_html) {
                this.editor = result.body_html;
            }
        })
        //get comment data for this order
        this.fetchOrderComments();
    },

    computed: {
        /**
         * This will group comments by the parent, and then sort by the parent that has the latest child comment
          */
        groupedComments() {
            const sortedComments = this.comments.sort((a, b) => (a.parentCommentId === null ? -1 : a.parentCommentId - b.parentCommentId));
            const grouped = {};
            sortedComments.forEach((item) => {
                const parentCommentId = item.parentCommentId;
                if (!parentCommentId) {
                    grouped[item.id] = {...item, children: []};
                } else {
                    if (!grouped[parentCommentId]) {
                        grouped[parentCommentId] = {children: []};
                    }
                    grouped[parentCommentId].children.push(item);
                }
            });

            const sortedGrouped = sortBy(grouped, function (c) {
                return new Date(c.date);
            });

            sortedGrouped.forEach((parent) => {
                if (parent.children && parent.children.length > 0) {
                    parent.maxChildUpdatedAt = maxBy(parent.children, 'date').date;
                } else {
                    parent.maxChildUpdatedAt = parent.date;
                }
            });

            const sortedGroupedLatestChild = orderBy(sortedGrouped, ['maxChildUpdatedAt'], ['desc']);

            return Object.values(sortedGroupedLatestChild);
        },
        /**
         * Don't allow any updates to this order
         *
         * @return void
         */
        isLocked() {
            return this.lockOrder === true;
        },

        isUnlocked() {
            return this.lockOrder === false;
        },

        /**
         * get the current editor charachter length
         *
         * @return Number
         */
        commentLength() {
            try {
                let len = 0;

                //get the length of all the text
                len = $(this.editor).text().trim().length;


                //add length for any images
                if ($('<div>' + this.editor + '</div>').find('img').length > 0) {
                    console.log('yesssss')
                    len = len + 1;
                }

                return len;

            } catch ($e) {
                return 0;
            }
        },
    },

    methods: {
        toggleDeletedComments() {
            this.deletedCommentsEnabled = !this.deletedCommentsEnabled;
        },
        fetchFileComments() {
            // axios file comment for the order
            axios(`/orders/${this.orderId}/files-comments`).then((result) => {
                if (result.data.status) {
                    let allComments = {};
                    let data = result.data.data;
                    const delimiter = "\n================\n";
                    data.forEach(item => {
                        let additionalComments = 0;
                        item.comments && item.comments.split(delimiter).filter(function (value, index) {
                            return index !== 0 && index !== (item.comments.length - 1);
                        }).map(function (value) {
                            let commentParts = value.split(':');
                            //Extracting the date
                            let date = commentParts[0].split(' ')[1] + ' ' + commentParts[0].split(' ')[2] + ':' + commentParts[1].split(' ')[0];

                            const fullNameRegex = /by\s(.+?)\s\(/;
                            let fullNameMatch = commentParts[1].match(fullNameRegex);
                            let fullName = fullNameMatch ? fullNameMatch[1] : "";


                            const emailRegex = /\((.*?)\)/;
                            let emailMatch = commentParts[1].split('by')[1].match(emailRegex);
                            let email = emailMatch ? emailMatch[1] : "";
                            let commentId = item.id + additionalComments;

                            allComments[commentId] = {
                                id: item.id,
                                orderId: item.orderid,
                                userId: item.fileid,
                                created_at: date,
                                updated_at: null,
                                htmlBody: commentParts[2].trim().replace(/^\n+|\n+$/g, ""),
                                textBody: commentParts[2].trim().replace(/^\n+|\n+$/g, ""),
                                mentionUsers: "",
                                systemEvent: false,
                                deleted: false,
                                byName: fullName,
                                byEmail: email,
                                byRole: null,
                                byCompany: null,
                                fileName: item.filename,
                                originalCommentId: null,
                                displayCreated: date,
                                isNotificationReply: 0,
                                roleColor: "#34c6eb"
                            };
                            additionalComments++;
                        });
                    });

                    data = values(allComments);
                    data = data.map(comment => {
                        return this.transformComment(comment);
                    }).reverse();


                    this.comments = data;
                    this.deletedComments = [];
                    this.systemComments = [];
                    this.isFetchingFileComments = true;
                    const latestComment = maxBy(this.comments, (comment) => new Date(comment.date));
                    this.highlightedCommentId = latestComment?.id;
                }
            }).catch((err) => {
                this.errorNotification('failed to fetch file comments! ', err.message);
                this.isFetchingFileComments = false;
            });
        },

        // Fetch Order Comments function
        fetchOrderComments() {
            this.isFetchingFileComments = false;
            return axios(`/orders/${this.orderId}/comments/all`).then(async (response) => {
                let {data} = response.data;

                data = values(data);

                data = await this.processComments(data);

                data = data.map(comment => {
                    return this.transformComment(comment);
                }).reverse();
                this.comments = data.filter(comment =>
                    comment.deleted === false && comment.system == false
                );
                this.deletedComments = data.filter(comment =>
                    comment.deleted === true && !comment.originalCommentId
                );

                this.systemComments = data.filter(comment =>
                    comment.system == true
                )
                this.isFetchingFileComments = false;
                this.editedComments = this._buildEditedCommentsObj(data);
                const latestComment = maxBy(this.comments, (comment) => new Date(comment.date));
                this.highlightedCommentId = latestComment.id;

            })
        },

        /**
         * Process comments
         *
         * @description - format comments properly.  Especially,
         * those returned from Sendgrid.
         *
         * @return Promise
         */
        async processComments(comments) {
            let processingComments = [];

            //go through each comments
            //find the ones that have been added using an email client
            comments.forEach(comment => {
                let {htmlBody, isNotificationReply} = comment;

                //@todo - this is a workaround.  Doesn't look like tiptap
                //has a paste command so we're simulating one here.
                const pasteContentToEditor = (content) => {
                    const pasteEvent = new ClipboardEvent('paste', {
                        clipboardData: new DataTransfer(),
                    });
                    pasteEvent.clipboardData.setData('text/plain', content);

                    // Dispatch the paste event to the editor
                    const editorElement = $('#hiddenedditor').find('[contenteditable]')[0];

                    editorElement.dispatchEvent(pasteEvent);
                };

                //if it has been added from an email client then we
                //send it to tiptap for formatting.
                if (isNotificationReply) {

                    //add the comment to the editor component for processing
                    processingComments.push(() => {
                        return new Promise((resolve, reject) => {
                            pasteContentToEditor(comment.htmlBody);

                            setTimeout(() => {
                                //set the processed html to the comment html body

                                comment.htmlBody = this.hiddenEditor;

                                resolve(true);
                            }, 100);
                        })
                    });
                }
            });

            //process each comment
            while (processingComments.length) {
                let comment = processingComments.pop();

                await comment();
            }

            return comments;
        },

        /**
         * get cached editor state
         *
         * @return Promise
         */
        getCommentCache() {
            return axios.get('/comment/cache', {
                params: {
                    comment_type: 'order',
                    comment_type_id: this.orderId
                }
            }).then(result => result.data);
        },

        /**
         * cache the current editor state
         *
         * @param {Object} editor
         * @param {Number} orderId
         * @return void
         */
        cacheComment: debounce((editor, orderId) => {
            let formData = new FormData();

            if (!editor) {
                editor = '<p></p>';
            }

            formData.append('comment_type', 'order');
            formData.append('comment_content', editor || '');
            formData.append('comment_type_id', orderId);

            const response = axios({
                method: 'post',
                url: '/comment/cache',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
            });
        }, 500),


        /**
         * normalize comment properties
         * (used when we first load comments)
         *
         * @todo - update property names on backend
         *
         * @param {Object} comment
         * @return {Object} comment
         */
        transformComment(comment) {
            let name = comment.byName.trim().split(' ');
            let emojiTextConversion = comment.textBody;
            let emojiHtmlConversion = comment.htmlBody;

            if (comment.isNotificationReply) {
                // Used when we load the comments.
                emojiTextConversion = emojiTextConversion.replace(/U\+([0-9A-Fa-f]{1,5})/g, (match, matchedString) => {
                    let codePoint = parseInt(matchedString, 16);
                    return String.fromCodePoint(codePoint);
                });
                // Used when we are trying to edit.
                emojiHtmlConversion = emojiHtmlConversion.replace(/U\+([0-9A-Fa-f]{1,5})/g, (match, matchedString) => {
                    let codePoint = parseInt(matchedString, 16);
                    return String.fromCodePoint(codePoint);
                });
            }
            return {
                id: comment.id,
                date: comment.created_at,
                firstName: name[0],
                lastName: name[1],
                deleted: comment.deleted,
                system: comment.systemEvent,
                userId: comment.userId,
                html: emojiHtmlConversion,
                roleColor: comment.roleColor,
                updatedAt: comment.updated_at,
                text: emojiTextConversion,
                originalCommentId: comment.originalCommentId,
                fileName: comment.fileName ?? null,
                isNotificationReply: comment.isNotificationReply,
                parentCommentId: comment.parentCommentId,
            }
        },

        /**
         * when a new comment is created normalize it's properties
         *
         * @param {Object} comment
         * @return {Object} comment
         */
        transformCreatedComment(comment) {
            return {
                id: comment.id,
                date: comment.display_created,
                firstName: comment.user.firstname,
                lastName: comment.user.lastname,
                deleted: false,
                system: false,
                userId: comment.user.id,
                html: comment.body_html,
                roleColor: null,
                parentCommentId: comment.parent_comment_id,
            }
        },

        /**
         * Get intitials of users name
         *
         * @param {String} firstName
         * @param {String} lastName
         * @return String
         */
        getInitials(firstName, lastName) {
            firstName = firstName.charAt(0).toUpperCase();
            lastName = lastName.charAt(0).toUpperCase();

            return firstName + lastName;
        },


        /**
         * Set comment editor to editing mode
         *
         * @param {Object} comment
         * @return void
         */
        editComment(comment) {
            this.editor = comment.html;
            this.editingComment = comment.id;
            this.editing = true;
        },
        replyToComment(comment) {
            this.replyingToComment = comment;
        },


        /**
         * Delete a comment
         *
         * @param {Array} comments
         * @param {Integer} id - the comment id
         * @return void
         */
        deleteComment(comments, id) {
            const indx = comments.findIndex(comment => comment.id == id);

            if (indx < -1) {
                console.error('failed to delete comment');
                return this.errorNotification('Failed to delete comment!');
            }

            //prevent double clicks
            if (this.deleteInProcess) {
                return this.errorNotification('waiting on response.');
            }

            const deleteComment = () => {
                const comment = Object.assign({}, comments.splice(indx, 1)[0]);
                const childComments = this.comments.filter(a => a.parentCommentId === comment.id);
                this.deleteCommentArray(childComments);
                this.deletedComments.unshift(...childComments);
                this.deletedComments.unshift(comment);
            };

            const params = {
                showdc: false,
                showsys: false,
            };

            this.deleteInProcess = true;

            axios
                .delete(`/orders/${this.orderId}/comments/delete/${id}`, params)
                .then(result => {
                    let {success} = result.data;

                    if (success) {
                        deleteComment();

                        this.successNotification('Comment Deleted!', 'Comment deleted successfully!');

                        //if user is in process of editing this comment
                        if (this.editing && this.editingComment == id) {
                            this.resetEdit();
                        }
                    } else {
                        console.error(`failed to delete comment: ${id}`);
                        this.errorNotification('failed to delete comment!');
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.errorNotification('Comment failed to update!');
                })
                .finally(() => {
                    this.deleteInProcess = false;
                })
        },

        /**
         * Delete children comments to the deleted comment
         *
         * @param {Array} comments
         * @return void
         */
        deleteCommentArray(comments) {
            comments.forEach(comment => {
                const index = this.comments.findIndex(c => c.id === comment.id);
                if (index !== -1) {
                    this.comments.splice(index, 1);
                }
            });
        },

        /**
         * Create a new comment
         *
         * @param {String} html
         * @return void
         */
        addComment(html, replyingToComment = null) {

            if (!html) {
                this.errorNotification('Comment Failure', 'no comment given');
                return console.error('no comment not input');
            }

            html = `<div>${html}</div>`;

            let $commentLength = $(html).text().length;

            //if a comment contains an image count it as atleast 1 charachter
            if ($(html).find('img').length) {
                $commentLength++;
            }

            if ($commentLength < 1) {
                this.errorNotification('Comment Failure', 'comment is not long enough');
                return console.error('comment not long enough');
            }

            if (this.postingCommentInProcess) {
                return this.errorNotification('Waiting on response.');
            }

            const params = {
                comment: html,
                showdc: false,
                showsys: false,
                parent_comment_id: replyingToComment?.id || null,
            };

            this.postingCommentInProcess = true;

            axios
                .post(`/orders/${this.orderId}/comments/store`, params)
                .then(result => {
                    let {comment, success} = result.data;

                    if (success) {
                        this.highlightedCommentId = comment.id;
                        this.comments.unshift(this.transformCreatedComment(comment));
                        this.successNotification('Comment Posted', 'comment posted successfully!');
                        this.resetEdit();
                    } else {
                        this.errorNotification('Failed to create comment!');
                        console.error('comment failed to post');
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.errorNotification('Comment failed to post!');
                })
                .finally(() => {
                    this.postingCommentInProcess = false;
                    this.replyingToComment = false;
                })

            /*let comment = {
              id: Date.now(),
              firstName: 'Sarah',
              lastName: 'West',
              date: moment().format(DATE_FORMAT),
              html
            };*/
        },


        /**
         * Update an existing comment
         *
         * @todo - when we edit a comment, the original is deleted.
         * It needs to be moved into the deleted comments and added
         * to the list of edited comments.  Right now, the user won't
         * see the historical comment until they refresh.
         * (2pt ticket max)
         *
         *
         * @param {String} editor
         * @param {Integer} editingComment - the comment id
         * @return void
         */
        saveComment(editor, editingComment) {
            if (!editingComment) {
                this.errorNotification('No comment to save!');
                return console.error('no comment to save');
            }

            if (this.editingCommentInProcess) {
                return this.errorNotification('updating comment.')
            }

            const params = {
                comment: editor,
                showdc: false,
                showsys: false
            };

            const updateComment = () => {
                let commentIndx = this.comments.findIndex(comment => comment.id == editingComment);
                const comment = this.comments[commentIndx];


                comment.html = editor;

                //@TODO - add the new comment id
                comment.originalCommentId = true;
                comment.updatedAt = moment().format(DATE_FORMAT);
            }

            this.editingCommentInProcess = true;

            axios
                .post(`/orders/${this.orderId}/comments/update/${editingComment}`, params)
                .then(result => {
                    let {comment, success} = result.data;

                    if (success) {
                        updateComment();

                        this.successNotification('Comment Updated', 'comment updated successfully!');
                        this.resetEdit();
                    } else {
                        console.error(`failed to udpate comment: ${editingComment}`);
                        this.errorNotification('failed to update comment!');
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.errorNotification('Comment failed to update!');
                })
                .finally(() => {
                    this.editingCommentInProcess = false;
                })
        },


        /**
         * Reset the editor
         *
         * @return void
         */
        resetEdit() {
            this.editor = '';
            this.editingComment = 0;
            this.editing = false;

            this.cacheComment(this.editor, this.orderId);
        },


        /**
         * Create an error notification
         *
         * @param {String} title
         * @param {String} message
         * @return void
         */
        errorNotification(title, message) {
            this._notification(title, message, 'error');
        },


        /**
         * Create an success notification
         *
         * @param {String} title
         * @param {String} message
         * @return void
         */
        successNotification(title, message) {
            this._notification(title, message, 'success');
        },


        _buildEditedCommentsObj(data) {
            let editedCommentsObj = {};
            let topLevelCommentsObj = {};

            //create an object containing all possible edited comments
            data.forEach(comment => {
                if (comment.system !== true && comment.deleted === true) {
                    editedCommentsObj[comment.id] = comment;
                }
            })

            //populate top level comments thread object
            data.forEach((comment) => {
                let id = comment.originalCommentId;

                //only pick the latest comments
                //that are the result of a previously edited comment
                if (id
                    && comment.deleted !== true
                    && comment.system !== true
                    && comment.originalCommentId
                    && !isArray(topLevelCommentsObj[id])
                ) {
                    topLevelCommentsObj[id] = [];
                }
            });

            //Add all of the top level comments edits to an array
            Object.keys(topLevelCommentsObj).forEach(commentid => {
                let commentsThread = topLevelCommentsObj[commentid];
                let topLevelComment = editedCommentsObj[commentid];

                //check if the comment has been edited
                if (topLevelComment) {

                    //get the previously edited comment
                    function next(comment) {
                        commentsThread.push(comment);

                        let nextComment = comment.originalCommentId;

                        return nextComment;
                    }

                    //continue to return the previous edited comments
                    //and add them to the top level comments array
                    const getCommentRelationships = (comment) => {
                        let nextComment = editedCommentsObj[next(comment)];

                        if (nextComment) {
                            getCommentRelationships(nextComment);
                        }
                    }

                    getCommentRelationships(topLevelComment);
                }
            });

            return topLevelCommentsObj;
        },


        /**
         * Create an error notification
         *
         * @param {String} title
         * @param {String} message
         * @param {String} type = 'error' or 'success'
         * @return void
         */
        _notification(title, message, type) {
            this.$notify({
                group: 'foo',
                type: type,
                title,
                text: message,
                duration: 1000,
                speed: 1000,
                animation: {
                    enter: {height: 200, opacity: 1, top: '10%', left: '10%'},
                    leave: {height: 0, opacity: 0, top: '10%', left: '10%'}
                },
                data: {}
            })
        }
    },

    template,

    data() {
        return {
            editor: '',
            hiddenEditor: '',
            editingComment: 0,
            systemCommentsEnabled: false,
            deletedCommentsEnabled: false,
            deleteInProcess: false,
            postingCommentInProcess: false,
            editingCommentInProcess: false,
            editing: false,
            replyingToComment: undefined,
            deletedComments: [],
            systemComments: [],
            comments: [],
            editedComments: {},
            isFetchingFileComments: false,
            highlightedCommentId: undefined,
        }
    },

    components: {
        PencilIcon,
        TrashCanIcon,
        ExclamationThickIcon,
        FlagIcon,
        Switches,
        PlusCircleIcon,
        CommentIcon,
        Comment
    }
};
</script>
